import * as React from 'react';
export const clockSvg = React.forwardRef(function clockSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M6 10.5A4.5 4.5 0 0 0 10.5 6c0-2.487-2.007-4.5-4.5-4.5a4.5 4.5 0 1 0 0 9ZM6 12a6 6 0 0 0 6-6c0-3.314-2.678-6-6-6a6 6 0 1 0 0 12Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M5.75 2.75a.75.75 0 0 1 .75.75v2.825l1.51.907a.75.75 0 1 1-.77 1.286L5.363 7.393A.75.75 0 0 1 5 6.75V3.5a.75.75 0 0 1 .75-.75Z',
    }),
  );
});
clockSvg.defaultProps = {
  width: '12',
  height: '12',
  viewBox: '0 0 12 12',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var clock = {
  category: 'icon',
  colorable: true,
  name: 'clock',
  svg: clockSvg,
};
